import { getUsers } from "store/userSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UsersTable from "./components/UsersTable";

const UsersDashboard = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  return (
    <div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <UsersTable />
      </div>
    </div>
  );
};

export default UsersDashboard;
